import { Permiso } from "@/shared/types/permiso";

export function PermisosListToMap(permisoList:Permiso[]){
    const allPermisos = Object.values(Permiso);
    const activePermisos = new Set(permisoList);

    return allPermisos.reduce((prev, permiso)=>{
        prev[permiso] = activePermisos.has(permiso);
        return prev;
    }, {} as Record<Permiso, boolean>)
}